import React from "react";
import { motion } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

/**
 * Small chevron button used to collapse/expand a chart card body.
 * Props:
 *   collapsed – boolean, current collapsed state
 *   onToggle  – () => void, toggle callback
 */
const CollapseToggle = ({ collapsed, onToggle }) => (
  <button
    onClick={onToggle}
    title={collapsed ? "Expand" : "Collapse"}
    style={{
      background: "none",
      border: "1px solid var(--color-border)",
      borderRadius: 6,
      width: 26,
      height: 26,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0,
      color: "var(--color-text-light)",
      transition: "background 0.15s, border-color 0.15s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(0,0,0,0.05)";
      e.currentTarget.style.borderColor = "rgba(0,0,0,0.18)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "none";
      e.currentTarget.style.borderColor = "var(--color-border)";
    }}
  >
    <motion.span
      animate={{ rotate: collapsed ? 180 : 0 }}
      transition={{ duration: 0.22, ease: "easeInOut" }}
      style={{ display: "flex", alignItems: "center" }}
    >
      <FaChevronDown size={10} />
    </motion.span>
  </button>
);

export default CollapseToggle;
